import type { SelectionState } from '@tilelist/application/ports/SelectionEvents.ts';
import type { OrderedPageLoads } from '@tilelist/application/wiring/OrderedPageLoads.browser.ts';
import type { TileListBrowserWiring } from '@tilelist/application/wiring/TileListBrowserWiring.browser.ts';
import type { TileListPageLayout } from '@tilelist/domain/composition/TileListPage.ts';
import {
    type SelectionContextProvider,
    registerSelectionContext,
} from '@tilelist/services/selection/SelectionContext.browser.ts';

/*                                                                               */
export function createFullListLifecycle(wiring: TileListBrowserWiring, pageLoads: OrderedPageLoads) {
    let active = true;
    let provider: SelectionContextProvider | undefined;
    let restoreSettled = false;
    let pending: { selection: SelectionState; page: TileListPageLayout } | undefined;

    function registerOrPublish(selection: SelectionState, page: TileListPageLayout): void {
        if (!wiring.session.onex.isToggleActive('REPTILE_1737_SELECTION_CONTEXT')) return;
        if (provider) provider.publish(selection, page);
        else provider = registerSelectionContext(selection, page, true);
    }

    return {
        async restore(page: TileListPageLayout): Promise<TileListPageLayout | undefined> {
            try {
                const restored = await pageLoads.restoreInitial(page, wiring.maybeRestoreFromCache);
                if (!active || pending || restored === undefined) return;
                registerOrPublish(wiring.selectionEvents.current(), restored);
                return restored;
            } finally {
                restoreSettled = true;
                if (active && pending) {
                    registerOrPublish(pending.selection, pending.page);
                    pending = undefined;
                }
            }
        },
        accept(selection: SelectionState, page: TileListPageLayout): void {
            if (!active) return;
            if (!restoreSettled) pending = { selection: { ...selection, page: { ...selection.page } }, page };
            else registerOrPublish(selection, page);
        },
        stop(): void {
            active = false;
            pending = undefined;
            provider?.stop();
        },
    };
}
